import React, { Component } from 'react';

// Interactions that could change form data. Scrolling (wheel, touch, scrollbar) is deliberately not
// blocked so locked content can still be read.
const BLOCKED_EVENTS = ['click', 'dblclick', 'mousedown', 'keydown', 'keypress', 'paste', 'cut', 'drop', 'dragstart'];

const blockEvent = e => {
    // allow keyboard focus to move through the page
    if (e.type === 'keydown' && e.key === 'Tab') return;

    e.preventDefault();
    e.stopPropagation();
};

/**
 * Renders its children read only. `disabled` handles native inputs, the capture listeners stop
 * custom widgets (selects, chips, uploaders, maps) before they see the event. These are native
 * listeners because React 16 dispatches synthetic events from the document, after the target's
 * own listeners have already run.
 */
class LockedFieldset extends Component {
    fieldset = React.createRef();

    componentDidMount() {
        BLOCKED_EVENTS.forEach(type => this.fieldset.current.addEventListener(type, blockEvent, true));
    }

    componentWillUnmount() {
        BLOCKED_EVENTS.forEach(type => this.fieldset.current.removeEventListener(type, blockEvent, true));
    }

    render() {
        return (
            <fieldset disabled className="form-locked" ref={this.fieldset}>
                {this.props.children}
            </fieldset>
        );
    }
}

export default LockedFieldset;
